const getQueryValue = () => {
	return document.getElementById('autocomplete-0-input')?.value;
};

export default getQueryValue;
